@import '../../stylesheets/defaults'
@import 'common/stylesheets/mixins/shortcut-keycap'

$arrow-size = 12px
$box-shadow = 0 2px 4px 0 (rgba(0, 0, 0, 0.16))

$small-width = 160px
$medium-width = 256px
$large-width = 400px

@keyframes fadeIn
  from
    opacity 0
  to
    opacity 1

+host-styles(mp-tooltip)
  display inline-block
  position fixed
  z-index $z-tooltip

  .mp-tooltip
    background-color var(--inverted-component-background-color)
    border-color var(--inverted-component-background-color)
    color var(--inverted-component-text-color)

    &.is-tooltip-tour
      background-color var(--background-color)
      border-color var(--component-background-color)
      color var(--component-text-color)

    &.is-dot-line-arrow
      &::after
        background-color var(--inverted-component-background-color)
        content ''
        height 2px
        left calc(var(--tooltip-offset) * -1)
        position absolute
        top 50%
        transform translateY(-50%)
        width var(--tooltip-offset)

      &::before
        background-color var(--inverted-component-background-color)
        border-radius 50%
        content ''
        height 10px
        left calc((var(--tooltip-offset) * -1) - 5px)
        position absolute
        top 50%
        transform translateY(-50%)
        width 10px

  .mp-tooltip-arrow::after
    background-color var(--inverted-component-background-color)

+host-styles(mp-tooltip, '[hidden]')
  display none

+host-styles(mp-tooltip, '[type="error"]')
  .mp-tooltip
    background-color var(--red1)
    border-color var(--red1)
    color $white

  .mp-tooltip-arrow::after
    background-color var(--red1)

.mp-tooltip
  border 1px solid
  border-radius 4px
  box-shadow $box-shadow
  cursor default
  font-family $family-helvetica
  font-size $font-size-small
  font-weight $weight-medium
  justify-content center
  letter-spacing normal
  line-height 14px
  padding 8px
  pointer-events auto
  position relative
  text-transform initial
  white-space pre
  set-all-box-sizing(border-box)

  &.is-tooltip-tour
    border none
    border-radius 12px
    box-shadow var(--drop-box-shadow)
    padding 16px

  &.break-word
    overflow-wrap break-word

  &.non-blocking
    pointer-events none

  +slotted-styles()
    display block

  .mp-tooltip-image
    width 100%

  .mp-tooltip-text
    // 2nd child to account for always-present slot
    &:not(:nth-child(2))
      margin-top 8px

    a
      color var(--gray3)
      text-decoration underline

      &:hover
        color var(--inverted-component-text-color)

    p
      margin 0

    em
      color var(--inverted-component-tertiary-text-color)
      font-style normal

    // For rendering keyboard shortcuts
    code
      shortcut-keycap(var(--inverted-component-secondary-background-color), var(--inverted-component-secondary-text-color))

      &:first-of-type
        margin-left 5px

        &:first-child
          margin-left 0

  &.is-hidden
    display none
    opacity 0
    pointer-events none

  &.is-transitioning
    pointer-events none
    visibility hidden

  &.is-visible
    opacity 1
    visibility visible

    &.is-animated
      animation fadeIn 250ms ease forwards

  &.has-max-width
    max-width 100%
    white-space pre-line
    width max-content

  // Arrow styles for each placement direction
  // Uses the "rotated square" method so we can keep a box-shadow and border radius on the tip
  .mp-tooltip-arrow
    height (2 * $arrow-size)
    overflow hidden
    position absolute
    transform-origin center
    width (2 * $arrow-size)

    &::after
      border-radius 2px
      box-shadow $box-shadow
      content ''
      height $arrow-size
      left ($arrow-size / 2)
      position absolute
      top -($arrow-size / 2)
      transform rotate(45deg)
      width $arrow-size

// applies max width on the tooltip element directly
// so that it does not overgrow because of the
// width: max-content in its root node
+host-styles(mp-tooltip, "[size='small']")
  max-width $small-width

  .mp-tooltip.has-image
    width $small-width

+host-styles(mp-tooltip, "[size='medium']")
  max-width $medium-width

  .mp-tooltip.has-image
    width $medium-width

    .mp-tooltip-image
      border-radius 4px

+host-styles(mp-tooltip, "[size='large']")
  max-width $large-width

  .mp-tooltip.has-image
    width $large-width

    .mp-tooltip-image
      border-radius 6px

// popper arrow positioning
+host-styles(mp-tooltip, "[data-placement^='top']")
  .mp-tooltip-arrow
    height $arrow-size
    left 50%
    top 100%

+host-styles(mp-tooltip, "[data-placement^='bottom']")
  .mp-tooltip-arrow
    bottom 100%
    height $arrow-size
    left 50%

    &::after
      top ($arrow-size / 2)

+host-styles(mp-tooltip, "[data-placement^='right']")
  .mp-tooltip-arrow
    height (2 * $arrow-size)
    right 100%
    width $arrow-size

    &::after
      top ($arrow-size / 2)

+host-styles(mp-tooltip, "[data-placement^='left']")
  .mp-tooltip-arrow
    height (2 * $arrow-size)
    left 100%
    width $arrow-size

    &::after
      left -($arrow-size / 2)
      top ($arrow-size / 2)
